import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import env from "./api/env";
import './filter/index'

import 'lib-flexible'

Vue.use(ElementUI);
Vue.prototype.$http= axios
axios.baseURL = env.baseURL
axios.baseURL2 = env.baseURL2


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
